import announcementReducer from './';

export default announcementReducer;
